import React, { FC } from 'react';
import { createPortal } from 'react-dom';
import { Modal, canUseDOM } from '@marriott/mi-ui-library';

import { PrivacyRightsModalProps } from './PrivacyRightsComponent.types';
export const PrivacyRightsModal: FC<PrivacyRightsModalProps> = ({
  showModal,
  className,
  labelledBy,
  modalHeaderContent,
  modalBodyContent,
  modalProceedButtonLabel,
  modalCancelButtonLabel,
  onClose,
  onProceed,
}) => {
  const legalModalRoot = document.getElementById('legal-modal-container');
  const canCreateModal = canUseDOM && legalModalRoot;
  return canCreateModal ? (
    createPortal(
      <Modal
        role="dialog"
        labelledBy={labelledBy}
        show={showModal}
        popupOpenState={showModal}
        handleBlur={true}
        setPopupOpenState={onClose}
        onClose={onClose}
        className={className}
      >
        <Modal.Header
          labelText={modalHeaderContent}
          customHeadingClass="t-subtitle-xl"
          popupHeaderOnCLoseFunc={onClose}
        />
        {modalBodyContent && (
          <Modal.Body className="p-5">
            <p>{modalBodyContent}</p>
          </Modal.Body>
        )}

        <Modal.FooterGeneric
          actions={
            <>
              <button className="m-button-m m-button-secondary" onClick={onClose} data-testid="modal-cancel-button">
                {modalCancelButtonLabel}
              </button>
              <button className="m-button-m m-button-primary" onClick={onProceed} data-testid="modal-proceed-button">
                {modalProceedButtonLabel}
              </button>
            </>
          }
        ></Modal.FooterGeneric>
      </Modal>,
      legalModalRoot
    )
  ) : (
    <h4>Modal Container is missing from document</h4>
  );
};
